import { PDKLenderIcon } from '@/components/ui/pdk-icons';
import type { Lender } from '@/models/types';
import { COMBO_BOX_OPTIONS } from '../combobox-popovers/all-filters-combobox-popover';
import LenderFiltersComboBoxPopover from '../combobox-popovers/lender-filters-combobox-popover';
import type { LenderFilterChipProps, LenderFiltersState } from '../types';
import BaseFilterChip from './base-filter-chip';

const LenderFilterChip = (props: LenderFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<Lender['id'], LenderFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={LenderFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS.find((option) => option.value === 'lender')?.icon
      }
      filterName="Lender"
      filterQuantifier={{
        singular: 'lender',
        plural: 'lenders',
      }}
      SelectedFilterBadge={() => {
        return <PDKLenderIcon className="h-3.5 w-3.5" />;
      }}
      showBadgeOnlyWhenOneIsSelected
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
    />
  );
};

export default LenderFilterChip;
